<form [formGroup]="form" (i360Submit)="login()">
    <mat-icon
            svgIcon="{{ is360Package ? 'logo-imunify' : 'logo-imunifyAV' }}"
            class="i360-logo"
            [class.imunifyav-logo]="!is360Package"
            i360Loader></mat-icon>
    <div class="i360-input">
        <span class="input-icon">
            <i class="material-icons">person</i>
        </span>
        <input type="text"
               class="input wide"
               name="i360-login"
               placeholder="{{'login.usernamePlaceholder' | translate}}"
               formControlName="username">
    </div>
    <div class="i360-input">
        <span class="input-icon">
            <i class="material-icons">lock</i>
        </span>
        <input type="password"
               class="input wide"
               name="i360-password"
               placeholder="{{'login.passwordPlaceholder' | translate}}"
               formControlName="password">
    </div>
    <div class="i360-error" *ngIf="error" [ngSwitch]="error">
        <ng-container *ngSwitchCase="LoginError.credentials">
            {{'login.error.credentials' | translate}}
        </ng-container>
        <ng-container *ngSwitchCase="LoginError.service">
            {{'login.error.service' | translate}}
        </ng-container>
    </div>
    <button class="i360-submit"
            color="primary"
            type="submit" mat-raised-button>
        {{'login.submit' | translate}}
    </button>
</form>
<mat-form-field>
    <mat-select [value]="appState.lang|async"
                (valueChange)="translate.use($event)">
        <mat-select-trigger>
            <mat-icon>language</mat-icon>
            Change language
        </mat-select-trigger>
        <mat-option *ngFor="let lang of translate.langs"
                    [value]="lang.code">
            {{lang.name}}
        </mat-option>
    </mat-select>
</mat-form-field>
